import React, { useEffect, useState } from "react";
import Layout1 from "../../Layouts/Layout1";
import { PropertyCardList } from "../common/PropertyCard/PropertyCard";
import FilterScreenModel from "../common/FilterScreenModel/FilterScreenModel";
import agency4 from "../../assets/agency-4.png";
import agent2 from "../../assets/agent-2.png";
import { toast } from "react-toastify";
import axiosInstance from "../../apiInstances/axiosInstance";
import { useSearchParams } from "react-router-dom";
import Savepropertypopup from "../savepropertypopup/savepropertypopup";
import VerticalAds from "../Adds/VerticalAds";
import { usePropertyData } from "../../context/PropertyDataContext";
import FilterNavTab from "../common/FilterNavTab/FilterNavTab";
import { AuthModal } from "../../models/AuthModal";
import RecentSoldProperties from "../common/RecentSoldProperties/RecentSoldProperties";
import { useGetAllListings } from "../../Hooks/useGetAllListings/useGetAllListings";
import { normalizePropertyList } from "../../utils/normalizePropertyList";
import { useFavoriteEvent } from "../../context/FavoriteContext";
import { PropertyCardSkeletonList } from "../Skeleton/PropertyCardSkeleton";
import LayoutContainer from "../../Layouts/LayoutContainer";

const BuyProperty = () => {
  const [AuthPopUp, setAuthPopUp] = useState(false);
  const [savepropertypopup, setSavepropertypopup] = useState(false);
  const [IsOpen, setIsOpen] = useState(false);
  const [BuyPropertyData, setBuyPropertyData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const onClose = () => setSavepropertypopup(false);
  const [ads, setAds] = useState([]);
  const { getCachedData, cachePropertyData } = usePropertyData();
  const [searchParams] = useSearchParams();
  const encryptedData = searchParams.get("encryptedData");
  const {
    error: listingsError,
    refetch: listingsRefetch,
  } = useGetAllListings("Active");

  const { favoriteEvent } = useFavoriteEvent();

  useEffect(() => {
    if (AuthPopUp || savepropertypopup || IsOpen) {
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
    }
    return () => {
      document.body.classList.remove("modal-open");
    };
  }, [AuthPopUp, savepropertypopup, IsOpen]);

  useEffect(() => {
    const fallbackState = "NSW";
    if (!navigator.geolocation) {
      getAdsList(fallbackState);
      return;
    }

    navigator.geolocation.getCurrentPosition(
      async (pos) => {
        const { longitude, latitude } = pos.coords;
        const url = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`;
        axiosInstance(url)
          .then((data) => {
            const state = data?.data?.address?.state?.split(" ")?.[0] || fallbackState;
            getAdsList(state);
          })
          .catch(() => getAdsList(fallbackState));
      },
      () => getAdsList(fallbackState),
      {
        timeout: 10000,
        maximumAge: 300000,
      }
    );
  }, []);

  const allpropertyid =
    BuyPropertyData?.length > 0 &&
    BuyPropertyData?.map((data) => {
      if (data?._id) {
        return data?.id;
      }
      return data.id;
    });

  const search = async () => {
    let userData = null;
    try {
      const raw = localStorage.getItem("userData");
      userData = raw ? JSON.parse(raw) : null;
    } catch {
      userData = null;
    }
    if (!encryptedData) {
      throw new Error("Missing search filters");
    }
    const res = await axiosInstance.post("/searchProperty", {
      userId: userData?.id ?? null,
      encryptedData,
    });
    if (res?.data?.status) {
      const mydata = res?.data?.data || [];
      const enriched = mydata.map((obj) => ({
        ...obj,
        agencyImg: agency4,
        agentImg: agent2,
      }));

      return normalizePropertyList(enriched);
    }
    throw new Error(res?.data?.message || "Search failed");
  };

  useEffect(() => {
    const fetchData = async () => {
      const cacheKey = "buy";

      try {
        setIsLoading(true);

        if (favoriteEvent) {
          const result = encryptedData
            ? await search()
            : await listingsRefetch();

          setBuyPropertyData(result);

          if (!encryptedData) {
            cachePropertyData(cacheKey, result);
          }
          return;
        }

        if (encryptedData) {
          const result = await search();
          setBuyPropertyData(result);
          return;
        }

        const cachedData = getCachedData(cacheKey);

        if (cachedData) {
          setBuyPropertyData(cachedData);
          return;
        }

        const result = await listingsRefetch();

        setBuyPropertyData(result);

        cachePropertyData(cacheKey, result);
      } catch (error) {
        console.error("Error:", error);
        toast.error(error.message || "Something went wrong");
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [encryptedData, favoriteEvent]);

  const getAdsList = (state) => {
    axiosInstance
      .get(`/advertise/ads/list?address=${state}`)
      .then((res) => {
        const result = res.data.data;
        setAds(result);
      })
      .catch((error) => console.log("err --->", error));
  };

  const sidebarAds = Array.isArray(ads?.verticalAds)
    ? ads.verticalAds.slice(0, 1)
    : [];

  return (
    <Layout1>
      <div className="bg-white border-t z-50 shadow-sm">
        <FilterNavTab currentTab={"Buy"} dataCount={BuyPropertyData?.length} />
      </div>
      <LayoutContainer>
        <div className="w-full flex flex-col lg:flex-row items-start gap-8 my-10 lg:my-16">
          <div className="flex flex-col gap-6 w-full flex-1 min-w-0 lg:max-w-[910px]">
            {isLoading ? (
              <PropertyCardSkeletonList count={5} />
            ) : (
              <PropertyCardList
                PropertyData={BuyPropertyData}
                setPropertyData={setBuyPropertyData}
                style="mb-5"
                adsList={ads.betweenAds}
              />
            )}
          </div>

          <div className="hidden sticky top-6 lg:block shrink-0 lg:w-[265px] xl:w-[300px] 2xl:w-[360px]">
            <div className="w-full">
              {sidebarAds.length > 0 &&
                sidebarAds.map((items, index) => {
                  return (
                    <VerticalAds adsList={items} key={index} />
                  );
                })}
            </div>
          </div>
        </div>
      </LayoutContainer>

      <RecentSoldProperties />
      {savepropertypopup ? (
        <Savepropertypopup allpropertyid={allpropertyid} onClose={onClose} />
      ) : null}

      {AuthPopUp ? (
        <AuthModal open={AuthPopUp} onClose={() => setAuthPopUp(false)} />
      ) : null}

      <FilterScreenModel
        setIsOpen={setIsOpen}
        IsOpen={IsOpen}
        currentTab={"Buy"}
        dataCount={BuyPropertyData?.length}
      />
    </Layout1>
  );
};

export default BuyProperty;
